import store from '../store/Store';
import { mutator } from 'satcheljs';
import { setAutoInvokeActionAlreadyRan } from '../actions/cardActions';

export const setAutoInvokeActionAlreadyRanMutator = mutator(
    setAutoInvokeActionAlreadyRan,
    actionMessage => {
        const card = store.cards.get(actionMessage.cardId);
        if (card) {
            card.autoInvokeActionAlreadyRan = actionMessage.autoInvokeActionAlreadyRan;
        }
    }
);
